<template lang="pug">
    .component-reporting-action-buttons(v-if="entity")
        ul.dropdown.menu(v-if="item", data-dropdown-menu='', v-f="")
            li
                a(href='#Item-1') Action
                ul.menu
                    li
                        router-link(:to="{name:'edit-reporting', params:{id:entity.id}}") Edit
                    li
                        a(v-on:click="resolve", v-if="entity.status === 'PENDING_REVIEW' || entity.status === 'CONFIRMED'") Resolve
                    li
                        a(v-on:click="confirm" v-if="entity.status === 'PENDING_REVIEW'") Confirm
                    li
                        a(v-on:click="voided", v-if="entity.status === 'PENDING_REVIEW'") Void
        .dropdown-buttons(v-else)
            button.button.success(v-on:click="resolve", v-if="entity.status === 'PENDING_REVIEW' || entity.status === 'CONFIRMED'") Resolve
            button.button.warning(v-on:click="confirm", v-if="entity.status === 'PENDING_REVIEW'") Confirm
            button.button.alert(v-on:click="voided", v-if="entity.status !== 'VOIDED'") Void
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from "src/maggieHelper";

    export default {
        name: "ReportingActionButtons",
        components: {},
        data() {
            return {
                entity: null
            }
        },
        created() {
            if (!this.reporting) {
                KeplerBackofficeSdk.reportings.select(this.$route.params.id).get((item) => {
                    this.entity = item
                })
            } else {
                this.entity = this.reporting
            }
        },
        methods: {
            confirm() {
                this.$confirm('Are you sure?', 'Do you really want to confirm?', () => {
                    KeplerBackofficeSdk.reportings.select(this.entity.id).setConfirmed(function () {
                        MaggieHelper.notification('update-esit', 'Reporting confirmed');
                        location.reload()
                    })
                })
            },
            resolve() {
                this.$confirm('Are you sure?', 'Do you really want to resolve?', () => {
                    KeplerBackofficeSdk.reportings.select(this.entity.id).setResolved(function () {
                        MaggieHelper.notification('update-esit', 'Reporting resolved');
                        location.reload()
                    })
                })
            },
            voided() {
                this.$confirm('Are you sure?', 'Do you really want to void?', () => {
                    KeplerBackofficeSdk.reportings.select(this.entity.id).setVoided(function () {
                        MaggieHelper.notification('update-esit', 'Reporting voided');
                        location.reload()
                    })
                })
            }
        },
        props: ['reporting', 'item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// ReportingActionButtons.vue?5be9e056